/**
 * Copyright (c) 2019, YUNXI. All rights reserved.
 * YUNXI PROPRIETARY/CONFIDENTIAL. Use is subject to license terms.
 */
/**
 * Date         : 2021-05-11 15:47:54
 * description  : 描述
 * author       : zhizhan
 */
import "./index.less";
import React from "react";
import UploadS3 from "./Upload-S3";
import UploadOss from "./Upload-Oss";
import UploadMinio from "./Upload-minio";
import UploadFileAws from "./Upload-Aws";
import { get, set } from "../../../utils/index";
import UploadFileHuawei from "./Upload-huawei";
import { YxComponent } from "../../YxComponent";
import UploadFile from "../../../utils/upload/uploadFile";
import { cloneDeep, isFunction } from "lodash";

/**
 * 组件选择器
 *
 * @class YxUpload
 * @extends {YxComponent}
 */
class YxUpload extends YxComponent {
  static UploadFile = UploadFile;

  constructor(props, context) {
    super(props, context);
  }
  classProcess = (props) => {
    let tmpProps = { ...props };
    //组件久时未使用合并props 和default 的修饰符所以只能手动设置默size
    if (!get(tmpProps, "styleParam.size", false)) {
      set(tmpProps, "styleParam.size", "default");
    }
    let classParam = {
      yx_yxUpload_image_: "styleParam.size",
    };
    let AccessToken = get(tmpProps, "AccessToken");

    let url = get(tmpProps, "url");
    let policyUrl = get(tmpProps, "policyUrl");
    let uploadType = get(tmpProps, "uploadType");

    if (isFunction(AccessToken)) tmpProps.AccessToken = AccessToken(); //为了支持编辑器的函数属性功能
    if (isFunction(url)) tmpProps.url = url();
    if (isFunction(policyUrl)) tmpProps.policyUrl = policyUrl();
    if (isFunction(uploadType)) tmpProps.uploadType = uploadType();

    tmpProps.className = this.styleParamClassName(tmpProps, classParam);
    return tmpProps;
  };
  render() {
    const uploadType = get(this.props, "uploadType", "oss");
    const dictFromUpload = {
      // s3: UploadS3,
      oss: UploadOss,
      minio: UploadMinio,
      aws: UploadFileAws,
      huawei: UploadFileHuawei,
      jd: UploadFileAws,
    };
    const DOM = get(dictFromUpload, uploadType, () => <div />);
    return <DOM {...this.classProcess(this.props)} />;
  }
}

export default YxUpload;



// WEBPACK FOOTER //
// ./src/yx-widget/component/YxInput/YxUpload/YxUpload.js